/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsSideBySideTextAndImageViewProps } from './../../../modules/hosports-side-by-side-text-and-image/./hosports-side-by-side-text-and-image';
//@ts-ignore
import SideBySideImageAndText from './../../../baseComponents/side-by-side-image-and-text/./side-by-side-image-and-text';

export default (props: IHosportsSideBySideTextAndImageViewProps) => {
    let config = props.config;
    let image = config.image ? config.image.src : null;
    return (
        <SideBySideImageAndText
          title={config.title}
          preTitle={config.preTitle}
          description={config.description}
          image={image}
          buttonLink={config.buttonLink}
          buttonText={config.buttonText}
          theme={config.theme}
          direction={config.direction}
          resizeMode={config.resizeMode}
          height={config.height}
        />
    );
};
